// web/src/qr.ts —— 把二维码内容画成 data URL，供 <img> 直接用
//
// 为什么需要它：微信支付官方 Native 下单返回的是 `weixin://wxpay/bizpayurl?...` 这样的**文本**，
// 不是图片地址（虎皮椒会额外给一个 png 链接，所以那边不用画图）。这里用 MIT 的 qrcode-generator
// 在本地生成矢量二维码，不经过任何第三方二维码服务（不泄露内容、不依赖外部可用性）。

import qrcode from 'qrcode-generator';

/**
 * 生成二维码 SVG data URL。
 * 内容过长或内容非法时返回 null，调用方降级为显示纯文本（用户还能复制去微信里打开）。
 */
export function qrDataUrl(content: string): string | null {
  const trimmed = content.trim();
  if (trimmed === '') return null;
  try {
    // typeNumber 0 = 自动选版本；纠错级别 M（约 15% 冗余，屏幕扫码足够）
    const code = qrcode(0, 'M');
    code.addData(trimmed);
    code.make();
    // 矢量输出：带 width/height 属性（不依赖浏览器猜宽高比），显示尺寸交给 CSS
    const svg = code.createSvgTag({ cellSize: 4, margin: 2 });
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  } catch {
    return null;
  }
}

/** 内容看起来是图片地址吗（http/https）——是的话直接当 <img src>，不用画图 */
export function looksLikeImageUrl(content: string): boolean {
  return /^https?:\/\//i.test(content.trim());
}
